import { render, staticRenderFns } from "./coDriverBaseSalaryDialog.vue?vue&type=template&id=dd7c3906&scoped=true&"
import script from "./coDriverBaseSalaryDialog.vue?vue&type=script&lang=js&"
export * from "./coDriverBaseSalaryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7c3906",
  null
  
)

export default component.exports